import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../../store/index';
import * as ContactStore from '../../store/patient/Contact';
import DashboardNavMenu from '../../components/layout/menu/DashboardNav'
import { seo } from '../../helper/Script';
import ContentLoader from 'react-content-loader';
import Moment from 'moment';
import * as AccountStore from '../../store/siteaccount/Account';
import * as SubscriptionStore from '../../store/patient/Subscription';
import * as LanguageResourcesStore from '../../store/LanguageResoures';
import { scrollTop, setTittle, transcationstatusColor } from '../../helper/formvalidation';
import Pagination from "react-js-pagination";
import { dateFormat, dateUTCFormat, dateFormatConvert, timeFormatConvert } from '../../helper/formvalidation';
import { getDiscountPrice } from './Booking';

// At runtime, Redux will merge together...
type DocumentListProps =
    ContactStore.ContactState & SubscriptionStore.SubscriptionState & AccountStore.AccountState & LanguageResourcesStore.LanguageResouresState// ... state we've requested from the Redux store
    & typeof ContactStore.actionCreators & typeof SubscriptionStore.actionCreators & typeof AccountStore.actionCreators & typeof LanguageResourcesStore.actionCreators// ... plus action creators we've requested
    & RouteComponentProps<{ startDateIndex: string }>; // ... plus incoming routing parameters
var patientLocalStroage: any = localStorage.getItem('Patient');
var pat = JSON.parse(patientLocalStroage);
var languagecontent: any = "";
var langdata: any = "";
var __currency: any = [];
class DynamicForms extends React.PureComponent<DocumentListProps> {
    inputRef: any = React.createRef<HTMLInputElement>();
    constructor(props: any) {
        super(props);

    }
    state = {

        activePage: 1,
        activePagecount: 10,
        currentPagecount: 1,
        lists: []

    }

    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
        scrollTop();

    }
    componentDidUpdate() {
        seo(setTittle(languagecontent == "" ? "" : "Subscription"));

    }
    public render() {
        return (
            <React.Fragment>
                {this.renderSubscriptionList()}
            </React.Fragment>
        );
    }
    onCancel() {
        var x = document.getElementById("showCrop");
        var croppedImageUrl = "";
        var croppedImageUrlrevert = "test";
        const src = "";
        const crop = "";
        if (x != null) {
            if (x.style.display === "block") {
                x.style.display = "none";
            } else {
                x.style.display = "block";
            }
        }
        this.setState({ src: "" });
        this.inputRef.current.value = null;
        this.setState({ croppedImageUrl, croppedImageUrlrevert });
    }

    private ensureDataFetched() {
        this.props.getLangResources();
        this.props.getSubscriptionList();
        if (localStorage.getItem("LangResourcesValidations") != null)
            langdata = JSON.parse(localStorage.getItem("LangResourcesValidations") || "");



    }


    convertDate(time: any) {

        return Moment.utc(time).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('D MMM YYYY')
    }
    convertTime(time: any) {

        return Moment.utc(time).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('LT')
    }
    //handlePageChange(pageNumber: any) {
    //	var page = (pageNumber * 10) - 10;
    //	var pagenumber = page + 1;
    //	//console.log(page, pageNumber * 10)
    //	this.setState({ activePage: pageNumber, activePagecount: pageNumber * 10, currentPagecount: pagenumber });
    //	this.setState({ lists: this.props.paymentDetail.slice(page, pageNumber * 10) })
    //	//console.log(this.props.paymentDetail.slice(5, 10), "this.props.paymentDetail.slice(page, pageNumber * 5)")
    //}

    /*componentWillMount() {
        this.setState({ lists: this.props.paymentDetail.slice(0, 5) })
    }*/

    private renderSubscriptionList() {


        languagecontent = this.props.LanguageResoures;
        var _currency: any = "";
        __currency = this.props.Settings.filter((s: any) => s.name == "Currency");
        //var value: any;
        if (__currency.length == 0) {
            _currency = "";
        }
        else {
            if (__currency[0].value == "") {
                _currency = __currency[0].displayCode;
                localStorage.setItem("currency", _currency);
            }
            else {
                _currency = __currency[0].customizeValue;
                localStorage.setItem("currency", _currency);
            }


        }

        var currency: any = _currency;
        return (
            <React.Fragment>
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <DashboardNavMenu />
                            <div className="col-md-7 col-lg-8 col-xl-9">
                                <div id="pat_appointments" className="tab-pane fade show active">
                                    <div className="card card-table mb-0">
                                        <div className="card-body" style={{ padding: "10px" }}>
                                            {
                                                this.props.isLoading == true ? <ContentLoader title={langdata['loading'] == undefined ? "" : langdata['loading']} viewBox="0 0 400 100">
                                                    <rect x="0" y="20" rx="4" ry="4" width="400" height="15" />
                                                    <rect x="0" y="50" rx="4" ry="4" width="400" height="15" />
                                                    <rect x="0" y="80" rx="4" ry="4" width="400" height="15" />
                                                </ContentLoader> :
                                                    <React.Fragment>
                                                        <div className="table-responsive doc-module">
                                                            {
                                                                this.props.sublists.length == 0 ?
                                                                    <div className="p-4 center">{languagecontent['norecordsfound']}</div> :
                                                                    <div className="">                                                                        
                                                                        <table className="table table-hover table-center mb-0 transactiontable">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Plan Name</th>
                                                                                    <th>Enrolled On</th>
                                                                                    <th>Validity Period</th>
                                                                                    <th>Frequency Value</th>
                                                                                    <th>Status</th>
                                                                                    <th></th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>                                                                               
                                                                                {(this.state.lists.length > 0 ? this.state.lists : this.props.sublists.slice(0, 10)).map((transaction: SubscriptionStore.SubList) =>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <span style={{ height: '40px', fontSize: '25px', float: 'left', marginLeft:'-30px' }} className="nav-item dropdown has-arrow logged-item pr-0" >
                                                                                                <a href={"#collapseExample"} className="dropdown-toggle nav-link" data-toggle="collapse">
                                                                                                </a>
                                                                                            </span>
                                                                                            <span>{transaction.name}<br />({transaction.frequency})                                                                                             
                                                                                            </span>
                                                                                        </td>
                                                                                        <td>{dateFormat(transaction.enrolledOn)}</td>
                                                                                        <td>{isWithinTrial(transaction.paidDate, transaction.enrolledOn, transaction.trialDays, transaction.frequency) ? dateFormat(transaction.enrolledOn) + '-' + dateFormat(getTrialEndDate(new Date(transaction.enrolledOn), transaction.trialDays, transaction.frequency)) : dateFormat(transaction.enrolledOn) + '-' + dateFormat(transaction.expirationDate) }</td>
                                                                                        <td>{transaction.description}</td>
                                                                                        <td>{isWithinTrial(transaction.paidDate, transaction.enrolledOn, transaction.trialDays, transaction.frequency) ? "Trailing" : "Active" }</td>                                                                                        
                                                                                        <td>
                                                                                            {/*<br />*/}
                                                                                            {/*<button className="btn btn-md btn-primary float-right" type="button" onClick={() => this.onCancel()}>  Cancel </button>*/}
                                                                                            {/*<br /> <br />*/}
                                                                                        </td>
                                                                                    </tr>

                                                                                )
                                                                                }</tbody>
                                                                            <tbody id={"collapseExample"} className=" collapse"> 

                                                                                <tr style={{ borderLeft: "7px solid rgb(194 184 184)" }}>
                                                                                    <th>Transaction Date</th>                                                                                   
                                                                                    <th>Description</th>
                                                                                    <th>Amount</th>
                                                                                    <th>Payment Status</th>
                                                                                </tr>

                                                                                {

                                                                                    this.props.sublists.map((child: SubscriptionStore.SubList) =>
                                                                                        <tr >
                                                                                            <td>{dateFormat(child.paidDate)}  </td>                                                                                            
                                                                                            <td>{isWithinTrial(child.paidDate, child.enrolledOn, child.trialDays, child.frequency) ? "Free Trial (" + 
                                                                                               getTrialPeriodString(child.trialDays)
                                                                                                + ")" : "Subscription Charge -" + child.name + " (" + child.frequency + ")"}</td>
                                                                                            <td >{isWithinTrial(child.paidDate, child.enrolledOn, child.trialDays, child.frequency) ? 0.00 : child.amount}</td>
                                                                                            <td>{isWithinTrial(child.paidDate, child.enrolledOn, child.trialDays, child.frequency) ? "Trail" : child.paymentStatus}</td>
                                                                                        </tr>
                                                                                    )

                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                        {
                                                                            <p dangerouslySetInnerHTML={{ __html: getTrialDescriptionBlock(this.props.sublists[0].trialDescription, this.props.sublists[0].trialDays, this.props.sublists[0].enrolledOn, localStorage.getItem("currency") + this.props.sublists[0].amount + "/" + this.props.sublists[0].frequency, this.props.sublists[0].frequency) }}></p>

                                                                        }
                                                                    </div>

                                                            }
                                                        </div>



                                                    </React.Fragment>

                                            }
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.flexiform, ...state.contact, ...state.subscriptionDetail, ...state.account, ...state.langResources }), // Selects which state properties are merged into the component's props
    ({ ...ContactStore.actionCreators, ...SubscriptionStore.actionCreators, ...AccountStore.actionCreators, ...LanguageResourcesStore.actionCreators })// Selects which action creators are merged into the component's props
)(DynamicForms as any);



export function getTrialDescriptionBlock(trialdesc: string, trialdays: number, enrolledon: string, price : string, frequency: string) : string {
    if (trialdesc != "") {
        const enrolledOn = enrolledon;
        const trialDays = trialdays;
        const trialStartDate = new Date(enrolledOn);
        const trialEndDate = getTrialEndDate(trialStartDate, trialDays, frequency);
        const nextBillingDate = getNextBillingDate(trialStartDate, frequency, trialDays);
        const BillingStartDate = getPaymentStartDate(trialStartDate, trialDays, frequency);

        const trialPeriodString = getTrialPeriodString(trialDays);
        const trialStartDisplay = formatDisplayDate(trialStartDate);
        const trialEndDisplay = formatDisplayDate(trialEndDate);
        const nextBillingDisplay = formatDisplayDate(nextBillingDate);
        const BillingStartDisplay = formatDisplayDate(BillingStartDate);

        const freetrialfeq =  getTrialPeriodString(trialdays) + " (" + trialStartDisplay + " - " + trialEndDisplay + ")"
    

        const trialDescription = trialdesc
            .replace('{freetrialfrequency}', freetrialfeq)
            .replace('{trailstartdate}', BillingStartDisplay)
            .replace('{trialenddate}', trialEndDisplay)
            .replace('{nextbillingdate}', nextBillingDisplay)
            .replace('{price}',  price);

        return trialDescription;
    }
    return "";
}
export function getTrialStartDate(): Date {
    const appointmentTime = localStorage.getItem("AppointmentUTCTime");
    // Use current date if appointmentTime is null
    const baseDate = appointmentTime ? new Date(appointmentTime) : new Date();
    //baseDate.setDate(baseDate.getDate() + trialDays);
    return baseDate;
}

function isWithinTrial(paidDate: string, trialStartDate: string, trialDays: number, frequency: string): boolean {

    const trialEndDate = getTrialEndDate(new Date(trialStartDate), trialDays, frequency);
    const trialEndDisplay = formatDisplayDate(trialEndDate);
    return new Date(paidDate) <= new Date(trialEndDisplay);
}

// Returns a human-readable trial period string (e.g., "2 Months")
export function getTrialPeriodString(trialDays: number): string {
    if (trialDays < 30) {
        return `${trialDays} Day${trialDays > 1 ? 's' : ''}`;
    } else if (trialDays < 365) {
        const months = Math.floor(trialDays / 30);
        return `${months} Month${months > 1 ? 's' : ''}`;
    } else {
        const years = Math.floor(trialDays / 365);
        return `${years} Year${years > 1 ? 's' : ''}`;
    }
}

// Returns the trial end date (Date object)
export function getTrialEndDate(startDate: Date, trialDays: number, freq: string): Date {
    const endDate = new Date(startDate);
    const frequency = freq.toLowerCase();    
    if (frequency === "month" || frequency === "monthly") {
        endDate.setMonth(endDate.getDate() + (trialDays + 1));
    } else if (frequency === "year" || frequency === "yearly" || frequency === "annual") {
        endDate.setFullYear(endDate.getDate() + (trialDays + 1));
    }
    else
        endDate.setDate(endDate.getDate() + trialDays);
    return endDate;
}

export function getPaymentStartDate(startDate: Date, trialDays: number, freq: string): Date {
    const paymentDate = new Date(startDate);
    paymentDate.setDate(paymentDate.getDate() + trialDays); // -1 for inclusive range
    if (freq.toLowerCase() === "daily") {
        paymentDate.setDate(paymentDate.getDate() + 1);
    }
    else if (freq.toLowerCase() === "month" || freq.toLowerCase() === "monthly") {
        if (trialDays > 0) {
            const monthsToAdd = Math.floor(trialDays / 30);
            // If trial days result in at least one full month, add that many months.
            // Otherwise, default to adding one month for the next billing cycle.
            paymentDate.setMonth(paymentDate.getMonth() + (monthsToAdd > 0 ? monthsToAdd : 1));
        }
        else
            paymentDate.setMonth(paymentDate.getMonth() + 1);
    } else if (freq.toLowerCase() === "year" || freq.toLowerCase() === "yearly" || freq.toLowerCase() === "annual") {
        if (trialDays > 0) {
            const YeasToAdd = Math.floor(trialDays / 365);
            // If trial days result in at least one full month, add that many months.
            // Otherwise, default to adding one month for the next billing cycle.
            paymentDate.setFullYear(paymentDate.getFullYear() + (YeasToAdd > 0 ? YeasToAdd : 1));
        }
        else
            paymentDate.setFullYear(paymentDate.getFullYear() + 1);
    } else {
        // Default to adding 1 day if frequency is unknown
        paymentDate.setDate(paymentDate.getDate() + 1);
    }
    return paymentDate;
}



export function getNextBillingDate(trialEndDate: Date, freq: string, trialDays: number): Date {
    const nextBilling = new Date(trialEndDate);
    if (freq.toLowerCase() === "daily") {
        nextBilling.setDate(nextBilling.getDate() + 1);
    } else if (freq.toLowerCase() === "month" || freq.toLowerCase() === "monthly") {
        if (trialDays > 0) {
            const monthsToAdd = Math.floor(trialDays / 30);
            // If trial days result in at least one full month, add that many months.
            // Otherwise, default to adding one month for the next billing cycle.
            nextBilling.setMonth(nextBilling.getMonth() + (monthsToAdd > 0 ? monthsToAdd : 1));
        }
        else {
            nextBilling.setMonth(nextBilling.getMonth() + 1);
        }
    } else if (freq.toLowerCase() === "year" || freq.toLowerCase() === "yearly" || freq.toLowerCase() === "annual") {
        if (trialDays > 0) {
            const YeasToAdd = Math.floor(trialDays / 365);
            // If trial days result in at least one full month, add that many months.
            // Otherwise, default to adding one month for the next billing cycle.
            nextBilling.setFullYear(nextBilling.getFullYear() + (YeasToAdd > 0 ? YeasToAdd : 1));
        }
        else
        nextBilling.setFullYear(nextBilling.getFullYear() + 1);
    } else {
        // Default to adding 1 day if frequency is unknown
        nextBilling.setDate(nextBilling.getDate() + 1);
    }
    return nextBilling;
}

// Formats a Date object as "DD MMM YYYY"
export function formatDisplayDate(date: Date): string {    
   return Moment.utc(date).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('DD MMM YYYY hh:mm a')
}